var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIllustrationInvestigationalUse = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 68,
  height: 68,
  viewBox: "0 0 68 68",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#090C29",
  opacity: 0.9,
  width: 68,
  height: 68,
  rx: 34
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15 16)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#3A3F99",
  cx: 16.074,
  cy: 16.074,
  r: 16.074
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#3A3F99",
  d: "m37 37-9.705-9.705"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.869 24.869s-3.23-1.413-5.488-2.242c-1.481-.545-1.27-3.02-.413-3.95a6.748 6.748 0 0 0 2.013-5.594 4.725 4.725 0 0 0-1.273-3.692 4.82 4.82 0 0 0-3.634-1.504A4.82 4.82 0 0 0 12.44 9.39a4.725 4.725 0 0 0-1.274 3.691 6.748 6.748 0 0 0 2.013 5.594c.858.93 1.069 3.406-.412 3.95-2.258.83-5.488 2.244-5.488 2.244",
  stroke: "#348CFD"
})))));
export { SvgIllustrationInvestigationalUse as ReactComponent };
export default __webpack_public_path__ + "assets/images/illustration-investigational-use.svg";